import Swiper from 'swiper/bundle';
import $ from "jquery";
export default function reviewsSwiper() {

    let swiperReviews = new Swiper(".reviews-swiper", {
        rewind: true,
        spaceBetween: 50,
        slidesPerView: 1,
        navigation: {
            nextEl: ".reviews-swiper__button-next",
            prevEl: ".reviews-swiper__button-prev",
        },
        pagination: {
            el: ".reviews-swiper__pagination",
            clickable: true,
        },
    });
    function adjustHeightReviews() {
        let contentHeight = $('.reviews-content-container').height() + 160;
        $('.edv-reviews').height(contentHeight);
    }
    if(window.innerWidth > 992) {
        adjustHeightReviews();
    }

    $(window).resize(function() {
        if(window.innerWidth > 992) {
            adjustHeightReviews();
        }
        if(window.innerWidth <= 992) {
            $('.edv-reviews').height('100%');
        }

    });
}